import {SkillSearchConfig} from './skillSearch.types';

export const defaultSkillSearchConfig: SkillSearchConfig = {
  llmWeight: 0.8,
  keywordWeight: 0.2,
  minScore: 0.3,
  maxSkills: 3,
  gapThreshold: 0.3,
};

export const skillSearchPromptConfig = {
  continuationThreshold: 0.8,
  strongRelevanceMin: 0.6,
  strongRelevanceMax: 0.9,
  partialRelevanceMin: 0.3,
  partialRelevanceMax: 0.5,
};
